import React from "react";
import PropTypes from "prop-types";
import { Icon, message, Upload } from "antd";
import { BASE_URL } from "constants";
import { getAuthToken } from "utilities/auth";

class DocumentUploadWrapper extends React.Component {
    
    render() {
        return (
            <Upload
                disabled = {true}
                key={"upload"}
                {...{
                    directory: false, // Upload Directory Support
                    multiple: true, // Upload Multiple files support,
                    action:
                        `${BASE_URL}/case/${this.props.caseId}/document/upload/`,
                    showUploadList: false,
                    headers: {
                        Authorization: `Bearer ${
                            getAuthToken().authToken
                        }`
                    },
                    data: file => {
                        message.loading("Uploading File...", 0);
                        if(this.props.associateId && this.props.associateId !== "null") {
                            return {
                                file_name: file.name,
                                company: this.props.companyId,
                                document: this.props.documentId,
                                associate: this.props.associateId
                            };
                        } else {
                            return  {
                                file_name: file.name,
                                company: this.props.companyId,
                                document: this.props.documentId
                            };
                        }
                    },
                    onChange: ({ file }) => {
                        if (file.status === "done") {
                            message.destroy();
                            this.props.fetchChecklist();
                            message.success("File Uploaded");
                        }
                        if(file.status === "error") {
                            message.destroy();
                            message.error("Failed to Upload file");
                        }
                    }
                }}
            >
                <Icon type="upload" />
            </Upload>
        );
    }
}

DocumentUploadWrapper.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    documentId: PropTypes.number,
    fetchChecklist: PropTypes.func,
    associateId: PropTypes.number
};

export default DocumentUploadWrapper;